exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".v3-dialog-body{max-height:calc(100vh - 315px);scrollbar-gutter:stable;overscroll-behavior:contain;overflow-y:auto;padding:29.5px 15px 29.5px 30px}.v3-dialog-body.overflow-visible{overflow-y:visible;padding:29.5px 30px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader/lib!./src/componentsv3/Dialog/components/DialogBody/style.css
 ** module id = 1199
 ** module chunks = 0
 **/